import { CommunityMap, } from "@shared";
import { writable } from "../../utils/stores";
import { LocalMap } from "../map";
import { LocalSet } from "../set";
import {} from "../undo";
import { modifyWritable, notEq } from "../utils";
const localMap = () => new LocalMap();
const localSet = () => new LocalSet();
export class CommunityDetailsUpdatesManager {
    members = writable(new CommunityMap(), undefined, notEq);
    invitedUsers = writable(new CommunityMap(), undefined, notEq);
    blockedUsers = writable(new CommunityMap(), undefined, notEq);
    userGroups = writable(new CommunityMap(), undefined, notEq);
    bots = writable(new CommunityMap(), undefined, notEq);
    rules = writable(new CommunityMap(), undefined, notEq);
    #updateForCommunity(id, store, notFound, updater) {
        return modifyWritable((map) => {
            let val = map.get(id);
            if (val === undefined) {
                val = notFound();
                map.set(id, val);
            }
            return updater(val);
        }, store);
    }
    updateMember(id, userId, member) {
        return this.#updateForCommunity(id, this.members, localMap, (m) => m.addOrUpdate(userId, member));
    }
    removeMember(id, userId) {
        return this.#updateForCommunity(id, this.members, localMap, (m) => m.remove(userId));
    }
    inviteUsers(id, userIds) {
        return this.#updateForCommunity(id, this.invitedUsers, localSet, (set) => {
            const undos = userIds.map((u) => set.add(u));
            return () => {
                undos.forEach((u) => u());
            };
        });
    }
    uninviteUsers(id, userIds) {
        return this.#updateForCommunity(id, this.invitedUsers, localSet, (set) => {
            const undos = userIds.map((u) => set.remove(u));
            return () => {
                undos.forEach((u) => u());
            };
        });
    }
    blockUser(id, userId) {
        return this.#updateForCommunity(id, this.blockedUsers, localSet, (s) => s.add(userId));
    }
    unblockUser(id, userId) {
        return this.#updateForCommunity(id, this.blockedUsers, localSet, (s) => s.remove(userId));
    }
    deleteUserGroup(id, userGroupId) {
        return this.#updateForCommunity(id, this.userGroups, localMap, (s) => s.remove(userGroupId));
    }
    addOrUpdateUserGroup(id, userGroup) {
        return this.#updateForCommunity(id, this.userGroups, localMap, (s) => s.addOrUpdate(userGroup.id, userGroup));
    }
    removeBot(id, botId) {
        return this.#updateForCommunity(id, this.bots, localMap, (s) => s.remove(botId));
    }
    installBot(id, botId, perm) {
        return this.#updateForCommunity(id, this.bots, localMap, (s) => s.addOrUpdate(botId, perm));
    }
    updateRules(id, rules) {
        return modifyWritable((map) => {
            const prev = map.get(id);
            map.set(id, rules);
            return () => {
                if (prev !== undefined) {
                    map.set(id, prev);
                }
                else {
                    map.delete(id);
                }
            };
        }, this.rules);
    }
    clear() {
        this.members.set(new CommunityMap());
        this.invitedUsers.set(new CommunityMap());
        this.blockedUsers.set(new CommunityMap());
        this.userGroups.set(new CommunityMap());
        this.bots.set(new CommunityMap());
        this.rules.set(new CommunityMap());
    }
}
export const communityLocalUpdates = new CommunityDetailsUpdatesManager();
